export default {
  INVITATION_STATUS: {
    INACTIVE: { name: 'Aceptada', class: 'is-success', value: 0 },
    ACTIVE: { name: 'Pendiente', class: 'is-danger', value: 1 },
  },
}
